import Icon from '../components/Icon.vue'

Icon.register({
  'holly-berry': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M144 192c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM256 144c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48zM224 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM207.8 235.1c-0.4 39.8 7.4 78.1 22.9 112.3 4 8.9-2 19.2-11.7 20.2-15.2 1.5-30.4 4.6-45.3 9.1-14.9 4.5-23.8 19.9-20.2 35.1s8.5 29.9 14.7 43.8c4 8.9-1.9 19.3-11.6 20.2-35.9 3.4-71.6 14.9-104.8 33.9-12.4 7.1-27.5-1.6-27.6-16-0.1-38.2-8-74.9-23-107.7-4-8.9 2-19.2 11.7-20.2 15.2-1.5 30.4-4.6 45.3-9.1 14.9-4.5 23.8-19.9 20.2-35.1-3.6-15.2-8.5-29.9-14.7-43.8-4-8.9 1.9-19.3 11.6-20.2 37.3-3.5 74.4-15.9 108.7-36.2 10.7-6.4 23.9 1.3 23.8 13.7zM435 365.6c9.7 1 15.8 11.4 11.5 20.1-15 32.7-22.8 69.5-23 107.7 0 14.4-15.1 23.1-27.6 16-33.2-19-68.9-30.5-104.8-33.9-9.7-0.9-15.6-11.3-11.6-20.2 6.2-14 11.1-28.6 14.7-43.8 3.6-15.2-5.3-30.6-20.2-35.1-4.9-1.5-9.9-2.5-14.8-3.7 5.8-12.3 6.3-26.5 0.6-38.9-12.9-28.3-19.7-60.7-19.9-94 0-1.7 0.2-3.3 0.2-4.9-0.1-12.3 13.1-20 23.8-13.7 34.3 20.3 71.4 32.7 108.7 36.2 9.7 0.9 15.6 11.3 11.6 20.2-6.2 14-11.1 28.6-14.7 43.8-3.6 15.2 5.3 30.6 20.2 35.1 15 4.4 30.1 7.5 45.3 9.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/holly-berry.js
// module id = 1461
// module chunks = 0